module.exports = "\n@import url('https://fonts.googleapis.com/css?family=Open+Sans');\n/* You can add global styles to this file, and also import other style files */\n* {\n    font-family: 'Open Sans', sans-serif;\n}\nbody {\n    margin: 0;\n}\nhtml,body {\n    height: 100%;\n}\nngb-popover-window {\n    width: 274px;\n}"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./src/styles.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./src/styles.css
// module chunks = styles